export enum LoaderState {
  Idle,
  Loading,
  Loaded,
  Failed
}
